export default "/assets/Icon/RedCross.svg"